import React, {FC} from 'react'
import { useHistory } from 'react-router-dom'
import { Table } from 'semantic-ui-react'
import styled from 'styled-components'
//@ts-ignore
import LKButton from 'shared/LKButton'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { constants as DCConstants } from '../../../DetailsContainer'

import translate from '../../translator'
import Conditions from './Conditions'

import { GeneralTabProps } from '../../types.LoanDetails'

const Wrapper = styled.div`
  flex-direction: column;
`

export const TableKey = styled.div`
  &.with-btn {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}`

export const TableImportantValue = styled.div`
  color: black;
  font-size: 14px;
  font-weight: 700;
`

const GeneralTable = React.memo(({ rows }: {rows: ((string | JSX.Element)[] | (number | JSX.Element)[])[]}) => (
  <Table celled columns={2}>
    <Table.Body>
      {rows.map((row, index) => (
        <Table.Row key={index}>
          {row.map((column: string | number | JSX.Element, i: number) => (
            <Table.Cell key={`${index}${i}`}>{column}</Table.Cell>
          ))}
        </Table.Row>
      ))}
    </Table.Body>
  </Table>
))

const General: FC<GeneralTabProps> = (props) => {
  const { data: { base, conditions }, ID, hash } = props
  const history = useHistory()

  const handleClientButtonClick = ({ id, hashSumID, clientType }: {id: number, hashSumID: string, clientType: number }) => {
    if (clientType) {
      history.push(`/secure/client/${id}/details/${hashSumID}/${clientType}`)
    }
  }

  const createTableKey = (text: string) => {
    return <TableKey className="table-key">{translate(text)}</TableKey>
  }

  const keyWithClientButton = (FullName: string, params: {id: number, hashSumID: string, clientType: number }) => {
    return (
      <TableKey className="with-btn">
        <span>{FullName}</span>
        <LKButton
          onClick={() => handleClientButtonClick(params)}
          permission="VIEW_CLIENT"
          alias="client"
          disabled={!Number(params.id)}
        />
      </TableKey>
    )
  }

  const leftTableKeys = [
    [createTableKey('lbl_client_name_t'), base.FullName],

    [
      createTableKey('lbl_client2_fullname_t'),

      keyWithClientButton(base.CL2_FullName, {
        id: base.ClientID2,
        hashSumID: base.HashSum_ClientID2_,
        clientType: base.ClientType,
      }),
    ],

    [
      createTableKey('lbl_agree_t'),
      <TableImportantValue
        contentEditable
        suppressContentEditableWarning
        onFocus={() => requestAnimationFrame(() => document.execCommand('selectAll', false, null))}
        tabIndex="0"
      >
        {base.AgreementNo}
      </TableImportantValue>,
    ],

    [createTableKey('lbl_amount_t'), base.Amount + ' ' + base.ISO],

    [createTableKey('lbl_productgroup_t'), base.ProductGroup],

    [createTableKey('lbl_product_t'), base.Product],

    [createTableKey('lbl_cycle_t'), base.LoanCycle],

    [createTableKey('lbl_client_name_t'), base.ProductCycle],

    [
      createTableKey('LoanID'),
      <TableImportantValue
        contentEditable
        suppressContentEditableWarning
        onFocus={() => requestAnimationFrame(() => document.execCommand('selectAll', false, null))}
        onBlur={() => window.getSelection().removeAllRanges()}
        tabIndex="0"
      >
        {base.ID}
      </TableImportantValue>,
    ],
  ]

  const rightTableKeys = [
    [createTableKey('lbl_term_days_t'), `${base.TermDays} / ${Math.round(base.TermDays / 30.4375)}`],

    [
      createTableKey('lbl_client3_fullname_t'),

      keyWithClientButton(base.CL3_FullName, {
        id: base.ClientID3,
        hashSumID: base.HashSum_ClientID3_,
        clientType: base.ClientType,
      }),
    ],

    [
      createTableKey('lbl_disb_date_t'),
      `${LKDate.from(base.DisburseDate).toString()} / ${LKDate.from(base.CoverDate).toString()}`,
    ],

    [createTableKey('pan_accrual_method_t'), base.AccrualMethod],

    [createTableKey('lbl_annual_basis_t'), base.AnnualBasis],

    [createTableKey('lbl_revolving_t'), base.Revolving],

    [createTableKey('lbl_node_t'), base.Node],

    [createTableKey('lbl_resource_t'), base.ResourceTitle],

    [createTableKey('lbl_eir_t'), base.EIR],
  ]

  return (
    <Wrapper className="u-flex">
      <div className="u-flex u-padding-5">
        <div className="u-fluid u-marginRight-10">
          <GeneralTable rows={leftTableKeys} />
        </div>

        <div className="u-fluid">
          <GeneralTable rows={rightTableKeys} />
        </div>
      </div>
      {/*@ts-ignore*/}
      <Conditions
        instanceName={`${DCConstants.DetailsGridPrefixes.loan}-${base.ID}-Conditions`}
        ID={ID}
        hash={hash}
        ProductID={base.ProductID}
        ProductHash={base.HashSum_ProductID_} // eslint-disable-line
        data={conditions}
        base={base}
      />
    </Wrapper>
  )
}

export default General
